import { CheckIcon } from '@heroicons/react/20/solid';
import React from 'react';
import Image from 'next/image';
import heroImage from './ppc-new-design-hero-image.jpeg';


export function HeroSection({title, subtitle, bgImage}) {
  return (
<section className="w-full mx-auto md:px-4">
  <div className="relative w-full h-64 md:h-[600px] rounded-lg overflow-hidden">
  {bgImage && (
    <>
    <Image
      src={heroImage}
      alt="Background image"
      layout="fill"
      objectFit="cover"
      quality={75}
      className="bg-center"
      priority
    />
    {/* Gradient overlay (on top of the image) */}
    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-100" />
    </>
  )}

    
    

    <div className="relative h-full flex flex-col justify-center 
                    pl-8 md:pl-24 
                    w-full md:w-3/5 
                    px-4
                    pb-22 md:pb-28">

      <p className="text-xs md:text-sm text-gray-500 mb-2 pb-6 md:pb-12 font-dmsans">
        Updated: <br />
        <strong>
          {new Date().toLocaleString("default", { month: "long" })}{" "}
          {new Date().getFullYear()}
        </strong>{" "}
        by TopFlowerDelivery Staff
      </p>

      <h1 className="text-3xl md:text-5xl font-figtree font-semibold mb-4 w-[70%] md:w-[100%]">
        {title}
      </h1>
      <p className="hidden text-base md:text-xl max-w-xl">
        {subtitle}
      </p>
    </div>
    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-100/40" />
  </div>
</section>

    
  );
}
export default HeroSection;
